import clsx from "clsx";

import type { ReactNode } from "react";

export default function ContentContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        "flex grow flex-col max-h-full lg:bg-white lg:border lg:border-black-100 lg:rounded-3xl lg:shadow-xl overflow-hidden",
        className,
      )}
    >
      {children}
    </div>
  );
}
